var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manager_dashboard" },
    [
      _c("UserMenu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _vm.checkIsManager()
            ? _c("ManagerSidebarMenu", {
                attrs: {
                  show_menu: true,
                  show_back_button: false,
                  back_link: "managerReports"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.checkIsMentor()
            ? _c("MentorSidebarMenu", {
                attrs: {
                  show_menu: true,
                  show_back_button: false,
                  back_link: "mentorReports"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content-wrapper",
              staticStyle: { "padding-left": "165px" }
            },
            [
              _c("div", { staticClass: "container-wrapper center" }, [
                _c("div", { staticStyle: { "margin-bottom": "10px" } }),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-3" }, [
                  _c("div", { staticClass: "col-6 pr-3" }, [
                    _c("div", { staticClass: "shadow rounded px-3 py-3" }, [
                      _c("div", { staticClass: "row align-items-end" }, [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-4" },
                          [
                            _c("b-form-select", {
                              attrs: { options: _vm.menteeOptions, size: "sm" },
                              on: {
                                change: function($event) {
                                  return _vm.getCompetenciesEarned()
                                }
                              },
                              model: {
                                value: _vm.ecMenteeSelected,
                                callback: function($$v) {
                                  _vm.ecMenteeSelected = $$v
                                },
                                expression: "ecMenteeSelected"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-3" },
                          [
                            _c("b-form-select", {
                              attrs: { options: _vm.timeOptions, size: "sm" },
                              on: {
                                change: function($event) {
                                  return _vm.getCompetenciesEarned()
                                }
                              },
                              model: {
                                value: _vm.ecTimeSelected,
                                callback: function($$v) {
                                  _vm.ecTimeSelected = $$v
                                },
                                expression: "ecTimeSelected"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _vm.competencyGraghLoading == false
                            ? _c(
                                "div",
                                {
                                  staticClass: "mx-3 my-3 comp_chart_container"
                                },
                                [
                                  _c("apexchart", {
                                    attrs: {
                                      type: "area",
                                      options: _vm.earnedCompetenciesOptions,
                                      series: _vm.earnedCompetenciesData
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-6 pl-3 pr-2 pl-xl-4 pr-xl-3" },
                    [
                      _c("div", { staticClass: "shadow rounded px-3 py-3" }, [
                        _c("div", { staticClass: "row align-items-end" }, [
                          _vm._m(1),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-4" },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  options: _vm.menteeOptions,
                                  size: "sm"
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.getRepRecorded()
                                  }
                                },
                                model: {
                                  value: _vm.repsMenteeSelected,
                                  callback: function($$v) {
                                    _vm.repsMenteeSelected = $$v
                                  },
                                  expression: "repsMenteeSelected"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-3" },
                            [
                              _c("b-form-select", {
                                attrs: { options: _vm.timeOptions, size: "sm" },
                                on: {
                                  change: function($event) {
                                    return _vm.getRepRecorded()
                                  }
                                },
                                model: {
                                  value: _vm.repsTimeSelected,
                                  callback: function($$v) {
                                    _vm.repsTimeSelected = $$v
                                  },
                                  expression: "repsTimeSelected"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12" }, [
                            _vm.repsGraghLoading == false
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "mx-3 my-3 reps_chart_container"
                                  },
                                  [
                                    _c("apexchart", {
                                      attrs: {
                                        type: "area",
                                        options: _vm.repsRecordedOptions,
                                        series: _vm.repsRecordedData
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-6 pr-3" }, [
                    _c("div", { staticClass: "shadow rounded px-3 py-3" }, [
                      _c(
                        "div",
                        { staticClass: "h4 mt-3 mb-3 text-uppercase" },
                        [_vm._v("Reports")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row mb-3 report-panel-container" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "text-muted",
                              attrs: { to: { name: "pathwayprogressreports" } }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "border rounded text-center p-1 ml-2 text-muted",
                                  staticStyle: {
                                    width: "112px",
                                    "border-color": "#002F42 !important"
                                  }
                                },
                                [
                                  _c("img", {
                                    staticStyle: {
                                      width: "25px",
                                      "margin-top": "5px",
                                      "margin-bottom": "5px"
                                    },
                                    attrs: {
                                      src: require("@/assets/manager/Mentor Mentee Progress Report Icon.png")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "mb-0 small",
                                      staticStyle: { color: "#002F42" }
                                    },
                                    [_vm._v("Progress")]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              staticClass: "text-muted",
                              attrs: { to: { name: "competencyreport" } }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "border rounded text-center p-1 ml-2 text-muted",
                                  staticStyle: {
                                    width: "112px",
                                    "border-color": "#002F42 !important"
                                  }
                                },
                                [
                                  _c("img", {
                                    staticStyle: {
                                      width: "19px",
                                      "margin-top": "5px",
                                      "margin-bottom": "5px"
                                    },
                                    attrs: {
                                      src: require("@/assets/manager/competency_report_icon.png")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "mb-0 small",
                                      staticStyle: { color: "#002F42" }
                                    },
                                    [_vm._v("Competency")]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              staticClass: "text-muted",
                              attrs: { to: { name: "competencyauditTrail" } }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "border rounded text-center p-1 ml-2 text-muted mb-1",
                                  staticStyle: {
                                    width: "112px",
                                    "border-color": "#002F42 !important"
                                  }
                                },
                                [
                                  _c("img", {
                                    staticStyle: {
                                      width: "21px",
                                      "margin-top": "5px",
                                      "margin-bottom": "5px"
                                    },
                                    attrs: {
                                      src: require("@/assets/manager/Competency_audit_button.png")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "mb-0 small",
                                      staticStyle: { color: "#002F42" }
                                    },
                                    [_vm._v("Competency Audit")]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.checkIsManager()
                            ? _c(
                                "router-link",
                                {
                                  staticClass: "text-muted",
                                  attrs: { to: { name: "managerUsageReports" } }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "border rounded text-center p-1 ml-2 text-muted",
                                      staticStyle: {
                                        width: "112px",
                                        "border-color": "#002F42 !important",
                                        "margin-right": "0px !important"
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          width: "25px",
                                          "margin-top": "5px",
                                          "margin-bottom": "8px"
                                        },
                                        attrs: {
                                          src: require("@/assets/manager/usage_report_icon.png")
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticClass: "mb-0 small",
                                          staticStyle: { color: "#002F42" }
                                        },
                                        [_vm._v("Usage")]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.checkIsMentor()
                            ? _c(
                                "router-link",
                                {
                                  staticClass: "text-muted",
                                  attrs: { to: { name: "mentorUsageReports" } }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "border rounded text-center p-1 ml-2 text-muted",
                                      staticStyle: {
                                        width: "112px",
                                        "border-color": "#002F42 !important",
                                        "margin-right": "0px !important"
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          width: "25px",
                                          "margin-top": "5px",
                                          "margin-bottom": "8px"
                                        },
                                        attrs: {
                                          src: require("@/assets/manager/usage_report_icon.png")
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticClass: "mb-0 small",
                                          staticStyle: { color: "#002F42" }
                                        },
                                        [_vm._v("Usage")]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              staticClass: "text-muted",
                              attrs: { to: { name: "repaudittrail" } }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "border rounded text-center p-1 ml-2 text-muted",
                                  staticStyle: {
                                    width: "112px",
                                    "border-color": "#002F42 !important"
                                  }
                                },
                                [
                                  _c("img", {
                                    staticStyle: {
                                      width: "25px",
                                      "margin-top": "5px",
                                      "margin-bottom": "10px"
                                    },
                                    attrs: {
                                      src: require("@/assets/manager/tasks_icon_rep_audit_trail.png")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "mb-0 small",
                                      staticStyle: { color: "#002F42" }
                                    },
                                    [_vm._v("Tasks")]
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col-6 pl-3 pr-2 pl-xl-4 pr-xl-3",
                      staticStyle: { "margin-top": "20px" }
                    },
                    [_c("MenteeTasksLogged")],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "my-5" })
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-5" }, [
      _c("div", { staticClass: "h6 mb-0 font-weight-bold text-uppercase" }, [
        _vm._v("Earned Competencies")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-5" }, [
      _c("div", { staticClass: "h6 mb-0 font-weight-bold text-uppercase" }, [
        _vm._v("Reps Recorded")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d7ecbbd2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7ecbbd2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/manager/manage_reports.vue
// module id = null
// module chunks = 